import Axios from 'axios'
import store from '../store'
import { ADD_PENDING_REQUESTS, SUB_PENDING_REQUESTS } from '../store/_mutations'
import router from '@/router/router.js'
const BASE_URL = 'web/v1/'

const axios = Axios.create({
    baseURL: BASE_URL,
    withCredentials: true,
    headers: {
        'X-CSRF-TOKEN': document.querySelector('meta[name=csrf-token]').getAttribute('content'),
        'X-Requested-With': 'XMLHttpRequest',
        'X-App-Request': Math.floor(Date.now() / 1000),
    },
})

axios.interceptors.request.use(
    (config) => {
        store.commit(ADD_PENDING_REQUESTS)
        config.headers['X-Socket-ID'] = Echo.socketId() || 0
        return config
    },
    (error) => {
        store.commit(SUB_PENDING_REQUESTS)
        return Promise.reject(error)
    }
)

axios.interceptors.response.use(
    (response) => {
        store.commit(SUB_PENDING_REQUESTS)

        if (response.headers['x-csrf-token']) {
            axios.defaults.headers.common['X-CSRF-TOKEN'] = response.headers['x-csrf-token']
            axios.defaults.headers['X-CSRF-TOKEN'] = response.headers['x-csrf-token']
            document.querySelector('meta[name=csrf-token]').setAttribute('content', response.headers['x-csrf-token'])
        }

        return response
    },
    async (error) => {
        store.commit(SUB_PENDING_REQUESTS)

        const {
            config,
            response: { status, data: errorMessage },
        } = error

        const originalRequest = config
        if (419 === status) {
            try {
                const { data } = await Axios.get('regenerate-session')
                const { csrf_token } = data

                // Actualizar el token CSRF en el header y en el meta tag
                axios.defaults.headers.common['X-CSRF-TOKEN'] = csrf_token
                axios.defaults.headers['X-CSRF-TOKEN'] = csrf_token
                document.querySelector('meta[name=csrf-token]').setAttribute('content', csrf_token)
                originalRequest.headers['X-CSRF-TOKEN'] = csrf_token

                // Reintentar el request original
                return axios(originalRequest)
            } catch (tokenError) {
                // Manejar el error al regenerar el token
                return Promise.reject(tokenError)
            }
        }

        if (503 === status) {
            // Mostrar un modal con un mensaje de mantenimiento usando programación funcional
            const showMaintenanceModal = () => {
                const modal = document.createElement('div')
                Object.assign(modal.style, {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    background: 'rgba(0,0,0,0.7)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 9999,
                })

                const content = document.createElement('div')
                Object.assign(content.style, {
                    background: '#fff',
                    padding: '2rem',
                    borderRadius: '8px',
                    boxShadow: '0 2px 16px rgba(0,0,0,0.2)',
                    textAlign: 'center',
                    maxWidth: '90vw',
                    fontFamily: 'sans-serif',
                })

                content.innerHTML = `
                <h2 style="margin-bottom:1rem;">Mantenimiento en progreso</h2>
                <p>El sistema se encuentra en mantenimiento. Por favor, inténtalo de nuevo más tarde.</p>
            `

                modal.appendChild(content)
                document.body.appendChild(modal)
            }

            showMaintenanceModal()
        }

        if (401 === status) {
            return router.push({ name: 'errors.unauthorized' })
        }
        return Promise.reject(error)
    }
)

export { axios }
